//App info to render inside of modal
export function Info(){

    const about = `This is a tool for creating quick and dirty vector maps from scratch. The canvas represents a grid of unit vectors that can be edited with your mouse or finger. 
    
    Empty grid cells correspond to the vector (0,0,1); all others are in the XY plane.
    
    Download your map to use with a shader or some other program that reads data from PNG textures.
    
    `
    
    const encoding = `The XYZ components of each vector in the range -1 to 1 are remapped to the range 0 to 255, and the new values are written to the RGB channels of the corresponding pixel in the output texture.
    
    The alpha channel depends on the editor mode:
    
    By default, empty pixels are set to 0 and all others are 255.
    
    In normal map mode, alpha is always 255.
    
    `

    const controls = `Click and drag on the grid to add, rotate, and remove vectors

    Zoom: pinch | ctrl + wheel

    Pan: 2 finger drag | wheel | alt + drag

    Long press (mobile) or hover (desktop) for tooltips
    
    v 0.1.2
    ©2022 george lee`


    return(
        <div id="info">
            <h2 style={{fontSize:'2rem', fontWeight:'normal'}}>About</h2>
            <div>{about}</div>

            <h2 style={{fontSize:'2rem', fontWeight:'normal'}}>Encoding</h2>
            <div>{encoding}</div>     
            
            <h2 style={{fontSize:'2rem', fontWeight:'normal'}}>Controls</h2>
            <div>{controls}</div>
        </div>
    );

}